import React from "react"
import { Helmet } from "react-helmet";
import LayOut from "../../components/common/LayOut";

const MyAccount = (props) => {
  return (
    <>
      <Helmet>
        <title>My Account - Clarity Cooperative</title>
      </Helmet>
      <LayOut>
        <h1>This page is in Next JS</h1>
      </LayOut>
    </>
  );
};



export default MyAccount;
